import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'share-button',
  templateUrl: './share-buttons.component.html',
  styleUrls: ['./share-buttons.component.css']
})
export class ShareButtonsComponent {
  
  @Input() type: string = '';
  @Input() url: string = 'https://example.com';
  @Input() text: string = 'Check out this awesome website!';
  @Input() media: string = 'https://example.com/image.jpg';
  @Input() hashtags: string = 'example,website';

  @Output() sendShareDatalayerEvent = new EventEmitter();

  // Redes sin endpoint web de share: se copia el enlace al portapapeles (AM-4243)
  readonly clipboardFallbackTypes: Array<string> = ['instagram', 'tiktok', 'youtube'];
  linkCopied: boolean = false;

  constructor() {
  }

  get shareUrl(): string {

    const encodedUrl = encodeURIComponent(this.url);
    const encodedText = encodeURIComponent(this.text);
    const encodedMedia = encodeURIComponent(this.media);
    const encodedHashtags = encodeURIComponent(this.hashtags);

    switch (this.type) {
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      case 'twitter':
        return `https://twitter.com/share?url=${encodedUrl}&text=${encodedText}&hashtags=${encodedHashtags}`;
      case 'pinterest':
        return `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedText}`;
      case 'linkedin':
        return `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedText}`;
      case 'whatsapp':
        return `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`;
      case 'telegram':
        return `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
      case 'instagram':
        return 'https://www.instagram.com/';
      case 'tiktok':
        return 'https://www.tiktok.com/';
      case 'youtube':
        return 'https://www.youtube.com/';
      default:
        return '#';
    }

  }

  clickOnShareButton(method:string): void {
    if (this.clipboardFallbackTypes.indexOf(method) !== -1) {
      this.copyLinkToClipboard();
    }
    this.sendShareDatalayerEvent.emit(method);
  }

  private copyLinkToClipboard(): void {
    if (!navigator.clipboard) {
      return;
    }
    navigator.clipboard.writeText(this.url).then(() => {
      this.linkCopied = true;
      setTimeout(() => this.linkCopied = false, 2500);
    }).catch(() => { /* silencioso: no bloqueamos la navegacion del enlace */ });
  }

}
